let sideNav = document.querySelector( ".side-nav" );

sideNav.querySelectorAll( "li.menu-item-has-children" ).forEach( li => {
	let link = li.querySelector( "a" );
	let div = document.createElement( "div" );
	div.className = "menu-item__dropdown";
	link.appendChild( div );

	div.addEventListener( "click", (e) => {
		e.preventDefault();
		li.classList.toggle( "open" );
	} );
});